
import FormatterService from "@/service/FormatterService";

export default {
    name: "ShareFloatAndLiquidity",

    props: {
        shareFloatData: {
            type: Object,
            default: () => {},
        }
    },

    created() {
        this.format = new FormatterService();
    },
}
